
import {Component, Vue} from 'vue-property-decorator'
import OrderInfo from '@/model/modules/OrderInfo'
import OrderService from '@/service/modules/OrderService'
import FromUserService from '@/service/modules/FromUserService'
import BasePageableInfo from '@/model/modules/BasePageableInfo'
import FromUserInfo from '@/model/modules/FromUserInfo'
import CourierService from '@/service/modules/CourierService'
import CourierInfo from '@/model/modules/CourierInfo'

@Component
export default class OrderEditor extends Vue {
  item: OrderInfo = new OrderInfo()
  showState: boolean = false
  savingState: boolean = false
  saveSuccessCallback: any
  editable: boolean = false

  courierOptionsList: CourierInfo[] = []
  fromUserOptionsList: FromUserInfo[] = []

  mounted() {
    FromUserService.listWithUser({}, 0, 999999)
      .then((result: BasePageableInfo<FromUserInfo>) => {
        this.fromUserOptionsList = result.dataList
      })
    CourierService.listWithUser({}, 0, 999999)
      .then((result: BasePageableInfo<CourierInfo>) => {
        this.courierOptionsList = result.dataList
      })
  }

  showEditor(item: OrderInfo, editable: boolean, saveSuccessCallback: any) {
    this.item = JSON.parse(JSON.stringify(item))
    this.editable = editable
    this.saveSuccessCallback = saveSuccessCallback
    this.item.fromUserId = item.fromUserDto.id
    this.showState = true
  }

  saveEditor() {
    this.savingState = true
    OrderService.save(this.item)
      .then((result) => {
        if (result === '') {
          this.$alert('保存数据', '保存成功', {
            confirmButtonText: '确定'
          })
        } else {
          this.$alert(result, '保存失败', {
            confirmButtonText: '确定'
          })
        }
        this.savingState = false
        this.showState = false
        this.saveSuccessCallback()
      })
  }
}
